import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import PageNotFound from "../Components/ErrorHandler/PageNotFound";
import { Skeleton } from "antd";
import ProtectedLayout from "./ProtectedLayout";
import GlobalLayout from "./GlobalLayout";
import { ProtectRoutes, GlobalRoutes } from "./Routes";
import MyStore from "../Pages/CommonPages/MyStore";
export default function MainLayout() {
  const getElementWithAccess = (element) => {
    return element;
  };

  return (
    <Suspense fallback={<Skeleton loading={true} active className="my-3" />}>
      <Routes>
        <Route path="*" element={<PageNotFound />} />
        <Route path="/" element={<MyStore />} />
        {/* <Route path="/:id" element={<CheckOrder />} /> */}
        <Route element={<ProtectedLayout />}>
          {ProtectRoutes.map(({ path, element, roles }) => (
            <Route
              path={path}
              element={getElementWithAccess(element, roles)}
              key={path}
            />
          ))}
        </Route>
        <Route element={<GlobalLayout />}>
          {GlobalRoutes.map(({ path, element, ...res }) => (
            <Route path={path} {...res} element={element} key={path} />
          ))}
        </Route>
      </Routes>
    </Suspense>
  );
}
